export const getDiscountValue = (value: any) => {
  if (typeof value === 'number') return `${parseFloat((value * 100).toFixed(0))}`;
  return '';
};
